<template>
  <div class="page-con">
    <div class="page-con-header clearfix sel-modal-header">
      <Button type="primary" icon="ios-add" v-if="isHavePermission('car:createCar')" @click="showAddModal">新建车辆信息
      </Button>
      <Button type="primary" icon="ios-add" style="margin-left: 10px" v-if="isHavePermission('car:importCar')"
              @click="showTempModal">导入车辆信息
      </Button>
      <Button type="primary" icon="ios-add" style="margin-left: 10px" v-if="isHavePermission('car:download')"
              @click="exportCar">导出
      </Button>
      <Button type="primary" style="margin-left: 10px" v-if="isHavePermission('car:auth')" @click="setAuth(1)">认证审核
      </Button>
      <Button type="primary" style="margin-left: 10px" v-if="isHavePermission('car:cancelAuth')" @click="setAuth(2)">
        取消认证
      </Button>
      <Button type="primary" style="margin-left: 10px" v-if="isHavePermission('car:updateCardTruckExist')"
              @click="updateCardTruckExist">入网更新
      </Button>
      <Button type="primary" style="margin-left: 10px" v-if="isHavePermission('car:report')" @click="report">数据上报
      </Button>
    </div>
    <div class="search-box" style="margin-bottom: 10px;display: flex;align-items: center">
      <vxe-input v-model="carNum" type="search" placeholder="车牌号" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <Cascader class="cascader" v-model="carTypeText" :data="carTypeList" trigger="hover" style="width: 200px;height:34px;margin-left: 10px;" placeholder="车辆类型"></Cascader>
      <vxe-input v-model="owner" style="margin-left: 10px" type="search" placeholder="车辆所有人" @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-input v-model="transportCardNum" style="margin-left: 10px" type="search" placeholder="车辆道路运输证号"
                 @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <!--      <vxe-input v-model="archivesNum" style="margin-left: 10px" type="search" placeholder="车辆行驶证档案编号"-->
      <!--                 @search-click="search"-->
      <!--                 @keyup.enter.native="search"></vxe-input>-->
      <vxe-input v-model="businessNum" style="margin-left: 10px" type="search" placeholder="经营许可证号"
                 @search-click="search"
                 @keyup.enter.native="search"></vxe-input>
      <vxe-select v-model="hasFile" style="margin-left: 10px" placeholder="道路运输证正面"
                  :options="has_file"></vxe-select>
      <vxe-select v-model="truckExist" style="margin-left: 10px" placeholder="入网状态"
                  :options="has_file"></vxe-select>
      <vxe-select v-model="searchFormData.reportTime" style="margin-left: 10px" :options="timeOptions"
                  placeholder="上报时间"
      ></vxe-select>
      <div class="search-filter">
        <vxe-modal
            class="timeModal"
            v-model="open"
            width="460"
            height="400"
            :show-footer="false"
            :showHeader="false"
        >
          <template v-slot>
            <DatePicker
                :open="open"
                confirm
                type="daterange"
                :split-panels="true"
                placeholder
                style="width: 432px"
                @on-change="handleChange"
                @on-clear="handleClear"
                @on-ok="handleOk"
            >
              <span class="date-slot"></span>
            </DatePicker>
          </template>
        </vxe-modal>
      </div>
      <Button type="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 5px">
        搜索
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="reset" style="margin-left: 10px">重置</vxe-button>
      <vxe-button icon="vxe-icon--refresh" @click="refresh" style="margin-left: 10px">刷新</vxe-button>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          ref="xTable"
          class="table-style"
          highlight-hover-row
          show-footer
          show-overflow
          stripe
          align="center"
          border="none"
          :loading="loading"
          :data="tableData"
          :filter-config="{remote: true}"
          @sort-change="sortChangeEvent"
          @filter-change="filterTypeMethod"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          resizable
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="id" title="序号" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
            <Dropdown
                v-if="isHavePermission('car:updateCar') || isHavePermission('car:removeCar') || row.authStatus === 0 || row.authStatus === 3"
                trigger="click"
                style="margin-left: 20px;cursor:pointer" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <Button class="button-gengduo" v-if="isHavePermission('car:auth') && row.authStatus === 0"
                          @click="goAuth(row,1)"
                          style="color: #539FFF">认证审核
                  </Button>
                  <Button class="button-gengduo" v-if="isHavePermission('car:cancelAuth') && row.authStatus === 3"
                          @click="goAuth(row,2)">
                    取消认证
                  </Button>
                  <Button class="button-gengduo" v-if="isHavePermission('car:updateCar') && row.authStatus !== 3"
                          @click="openUpdateView(row)">
                    编辑
                  </Button>
                  <Button class="button-gengduo" v-if="isHavePermission('car:removeCar') && row.authStatus !== 3"
                          @click="commitDelete(row.id)"
                          style="color: #ed4014;">删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carNum" title="车牌号" width="100">
          <template slot-scope="{ row }">
            <div style="display: flex;align-items: center;justify-content: center">
              <span v-if="isHavePermission('car:queryCar')" @click="showDetail(row)"
                    style="color: #2D8CF0;cursor:pointer">{{ row.carNum }}</span>
              <span v-if="!isHavePermission('car:queryCar')">{{ row.carNum }}</span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column title="定位" width="80">
          <template slot-scope="{ row }">
            <Button class="navigate" custom-icon="iconfont icon-dingwei" @click="seeMap(row)"></Button>
          </template>
        </vxe-table-column>
        <vxe-table-column field="truckExist" title="入网" width="50">
          <template slot-scope="{ row }">
            <span>{{ row.truckExist | truckExist }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carType" title="车辆类型" width="120"></vxe-table-column>
        <vxe-table-column field="deadweight" title="核定载质量(吨)" width="120">
        </vxe-table-column>
        <vxe-table-column field="carColor" title="车牌颜色" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.carColor }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="owner" title="车辆所有人" width="240"></vxe-table-column>
        <vxe-table-column field="transportCardNum" title="道路运输证号" width="120"></vxe-table-column>
        <vxe-table-column field="businessNum" title="经营许可证号" width="200"
                          :filters="[{label: '已维护', value: 1}, {label: '未维护', value: 0}]"
                          :filter-multiple="false"></vxe-table-column>
        <!--        <vxe-table-column field="archivesNum" title="行驶证档案编号"></vxe-table-column>-->
        <vxe-table-column field="authStatus" title="认证状态" width="100"
                          :filters="[{label: '已认证', value: 3}, {label: '未认证', value: 0}]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span style="color: #F59A23">{{ row.authStatus | authStatus }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="reportStatus" title="上报" width="80"
                          :filters="[{label: '未上报', value: 0}, {label: '成功', value: 1},{label: '失败', value: 2}]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span>{{ row.reportStatus | reportStatus }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="reportCompany" title="上报企业" width="240">
          <template slot-scope="{ row }">
            <span>{{ row.reportCompany === 1 ? '携船网（福建）航运科技有限公司' : row.reportCompany }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="reportUser" title="上报人" width="100"
                          :filters="[]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span>{{ row.reportUser }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="reportTime" title="上报时间" width="200" remote-sort>
          <template slot-scope="{ row }">
            <span>{{ row.reportTime | timeFormat }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="120"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120" v-if="isHavePermission('global:viewCreateTime')"
                          remote-sort>
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <div v-show="trackFlag" class="trackBox">
      <div style="display: flex;justify-content: space-between;">
        <div style="margin-left: 10px;font-size: 14px;font-weight: bold;line-height: 30px;">车辆轨迹</div>
        <div @click="trackFlag = false"
             style="margin-right:5px;cursor: pointer;line-height: 30px;height: 30px;background: #409EFF;color: #fff;border-radius:5px;width:60px;font-size: 12px;font-size: 12px;text-align: center;">
          关闭
        </div>

      </div>
      <iframe ref="mapFrame" style="width:100%;height:85vh;overflow: hidden;" frameborder=0
              name="showHere"
              scrolling=auto :src="`${publicPath}carInfo/fwCar.html`"></iframe>
    </div>
    <vxe-modal v-model="createVisible" :title="createTitle" width="1400" height="860" @close="closeCreate" resize
               position="center">
      <create-car-modal @afterSave="closeCreateModal" ref="modalCreate"
                        @close="closeCar"></create-car-modal>
    </vxe-modal>
    <vxe-modal v-model="importVisible" :title="title" width="1200" height="600" @close="closeImport" resize
               position="center">
      <import-car-modal @afterSave="closeImportModal" ref="modalImport"></import-car-modal>
    </vxe-modal>
    <vxe-modal v-model="templateVisible" title="车辆信息导入" width="1000" height="620" @close="closeTemplate"
               position="center">
      <import @goImport="goImport" @close="closeTemplate" ref="modalTemplate"></import>
    </vxe-modal>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" position="center">
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
    <vxe-modal v-model="reportVisible" title="数据上报" width="500" height="300" resize position="center"
               destroy-on-close>
      <choose-report ref="reportModal" @close="closeReport" @report="carInfoReport"></choose-report>
    </vxe-modal>
  </div>
</template>

<script>
import CreateCarModal from "./CreateCarModal";
import ImportCarModal from "./ImportCarModal";
import $api from '@/apiProvider';
import Import from "@/components/common/Import"; // 导入
import getAuthOrization from "@/mixin/getAuthOrization";
import $C from "@/consts/index";
import moment from "moment";
import {hideLoading, isEmpty, postBlob, saveBlob, showLoading} from "@/utils/util";
import Message from "@/components/common/Message";
import ChooseReport from "@/components/modal/ChooseReport";
import {searchTime, SEARCH_TIME} from "@/filters/time";

export default {
  components: {CreateCarModal, ImportCarModal, Import, Message, ChooseReport},
  mixins: [getAuthOrization],
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100
      },
      timeOptions: SEARCH_TIME.options,
      carNum: null,
      owner: null,
      transportCardNum: null,
      archivesNum: null,
      businessNum: null,
      hasFile: null,
      truckExist: null,
      isDesc: null,
      orderBy: null,
      tableData: [],
      title: '',
      createTitle: '',
      loading: false,
      createVisible: false,
      importVisible: false,
      templateVisible: false,
      dict: [],
      has_file: $C.HAS_FILE_TYPE.options,
      trackFlag: false,
      publicPath: process.env.BASE_URL,
      authStatus: null,
      hasBusinessNum: null,
      records: [],
      messageVisible: false,
      message: '',
      reportVisible: false,
      open: false,
      searchFormData: {
        reportTime: null
      },
      reportStatus: null,
      reportCompany: null,
      reportUser: null,
      reportUserList: [],
      paramsObj: {},
      carTypeList: [],
      carTypeText: [],
    }
  },
  watch: {
    "searchFormData.reportTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("reportTime");
      },
    },
  },
  filters: {
    authStatus(val) {
      if (val != null) {
        if (val === 0) {
          return "未认证"
        }
        if (val === 1) {
          return "待审核"
        }
        if (val === 2) {
          return "未通过"
        }
        if (val === 3) {
          return "已认证"
        }
        if (val === 4) {
          return "已过期"
        }
      }
    },
    reportStatus(val) {
      if (val != null) {
        if (val === 0) {
          return "未上报"
        }
        if (val === 1) {
          return "成功"
        }
        if (val === 2) {
          return "失败"
        }
      }
    },
    truckExist(val) {
      if (val === 0) {
        return "否"
      } else if (val === 1) {
        return "是"
      } else {
        return "未更新"
      }
    }
  },
  mounted() {
    this.$bus.$on("车辆信息", () => {
      this.reset();
      this.search();
    });
    this.getDict();
    this.getReportUser();
    this.getCarType();
  },
  methods: {
    async getCarType() {
      let res = await $api.dict.get("searchTreeByCodeP", {
        parentcode: 40200,
      });
      if (res.status === 1) {
        let data = res.data;
        this.carTypeList = [];
        data.map((i) => {
          let obj = {
            label: i.dictText,
            value: i.dictCode,
            children: [],
          };
          i.children.map((j) => {
            obj.children.push({
              label: j.dictText,
              value: j.dictCode,
            });
          });
          if (obj.children.length === 0) {
            obj.disabled = true;
          }
          this.carTypeList.push(obj);
        });
      } else {
        this.$XModal.message(res.message);
      }
    },
    sortChangeEvent(sort) {
      if (sort.order == null) {
        this.isDesc = null;
        this.orderBy = null;
      } else {
        this.isDesc = sort.order === 'desc' ? 1 : 0;
        if (sort.field === 'createTime') {
          this.orderBy = 7;
        } else if (sort.field === 'reportTime') {
          this.orderBy = 12;
        }
      }
      this.queryCarList();
    },
    async getReportUser() {
      let res = await $api.reportData.get('reportUser', {
        reportType: 1
      });
      if (res.status === 1) {
        let data = res.data;
        data.map(i => {
          this.reportUserList.push({
            label: i.reportUser,
            value: i.reportUser
          })
        })
        let xTable = this.$refs.xTable;
        let column = xTable.getColumnByField('reportUser')
        xTable.setFilter(column, this.reportUserList);
        xTable.updateData();
      }
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    closeMessage() {
      this.messageVisible = false;
    },
    async goAuth(row, status) {
      showLoading();
      let res = await $api.carShip.request('authCarByPlat', {
        ids: [row.id],
        status: status
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success(status === 1 ? '认证成功' : '取消成功');
        this.queryCarList();
      } else {
        let data = res.data;
        let message = '';
        if (data.length > 0) {
          data.map(i => {
            message = message + i.failMsg + '\n';
          })
        }
        if (message === '') {
          this.$XModal.alert({
            message: "接口异常",
            status: "error",
          });
        } else {
          this.$refs.messageModal.setMessage(message);
          this.messageVisible = true;
        }
      }
    },
    async setAuth(status) {
      let records = this.records;
      if (records.length === 0) {
        this.$XModal.alert({
          message: '请选择至少一条车辆信息',
          status: "error",
        });
        return
      }
      let idList = [];
      records.map(i => {
        idList.push(i.id);
      })
      showLoading();
      let res = await $api.carShip.request('authCarByPlat', {
        ids: idList,
        status: status
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success(status === 1 ? '认证成功' : '取消成功');
        this.records = [];
        this.queryCarList();
      } else {
        let data = res.data;
        let message = '';
        if (data.length > 0) {
          data.map(i => {
            message = message + i.failMsg + '\n';
          })
        }
        if (message === '') {
          this.$XModal.alert({
            message: "接口异常",
            status: "error",
          });
        } else {
          this.$refs.messageModal.setMessage(message);
          this.messageVisible = true;
        }
      }
    },
    report() {
      let records = this.records;
      if (records.length === 0) {
        this.$XModal.alert({
          message: '请选择至少一条车辆信息',
          status: "error",
        });
        return
      }
      this.reportVisible = true;
      this.$nextTick(() => {
        this.$refs.reportModal.queryConfigList();
      });
    },
    closeReport() {
      this.reportVisible = false;
    },
    async carInfoReport(reportCompany) {
      let records = this.records;
      let idList = [];
      records.map(i => {
        idList.push(i.id);
      })
      showLoading();
      let res = await $api.reportData.request('carInfoReport', {
        ids: idList,
        reportCompany: reportCompany
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('上报成功');
        this.reportVisible = false;
        this.records = [];
        this.queryCarList();
      } else {
        let data = res.data;
        let message = '';
        if (data.length > 0) {
          data.map(i => {
            message = message + i.failMsg + '\n';
          })
        }
        if (message === '') {
          this.$XModal.alert({
            message: "接口异常",
            status: "error",
          });
        } else {
          this.$refs.messageModal.setMessage(message);
          this.messageVisible = true;
        }
      }
    },
    async updateCardTruckExist() {
      let records = this.records;
      if (records.length === 0) {
        this.$XModal.alert({
          message: '请选择至少一条车辆信息',
          status: "error",
        });
        return
      }
      let idList = [];
      records.map(i => {
        idList.push(i.id);
      })
      showLoading();
      let res = await $api.track.request('updateCardTruckExist', {
        idList: idList
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('更新成功');
        this.records = [];
        this.queryCarList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    selectChangeEvent({checked, row}) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({checked, records}) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    seeMap(row) {
      let that = this;
      let url = '/carShip/fwCarFrame';
      let isOpen = localStorage.getItem("isCarOpen");
      if (!isOpen) {
        this.fwCar = window.open(url);
        localStorage.setItem("isCarOpen", true);
        setTimeout(function () {
          that.fwCar.postMessage(JSON.stringify({carNum: row.carNum}), '*');
        }, 2000);
      } else {
        setTimeout(function () {
          that.fwCar.postMessage(JSON.stringify({carNum: row.carNum}), '*');
        }, 2000);
      }
    },
    filterTypeMethod({column, property, values, datas, filters, $event}) {
      this.page.currentPage = 1;
      if (property === "authStatus") {
        if (values.length > 0) {
          this.authStatus = values[0];
        } else {
          this.authStatus = null;
        }
      } else if (property === "businessNum") {
        if (values.length > 0) {
          this.hasBusinessNum = values[0];
        } else {
          this.hasBusinessNum = null;
        }
      } else if (property === "reportStatus") {
        if (values.length > 0) {
          this.reportStatus = values[0];
        } else {
          this.reportStatus = null;
        }
      }
          // else if (property === "reportCompany") {
          //   if (values.length > 0) {
          //     this.reportCompany = values[0];
          //   } else {
          //     this.reportCompany = null;
          //   }
      // }
      else if (property === "reportUser") {
        if (values.length > 0) {
          this.reportUser = values[0];
        } else {
          this.reportUser = null;
        }
      }

      this.queryCarList();
    },
    closeCar() {
      this.createVisible = false;
      this.$refs.modalCreate.clearV();
    },
    showTempModal() {
      this.$refs.modalTemplate.setExport('713车辆信息导入模板.xls');
      this.templateVisible = true;
    },
    goImport() {
      this.templateVisible = false;
      this.title = '车辆信息导入'
      this.$refs.modalImport.setExport(true);
      this.importVisible = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    async exportCar() {
      if (isEmpty(this.tableData)) {
        this.$XModal.message("暂无数据");
        return;
      }
      showLoading();
      let res = postBlob("/api/order/carship/exportCar", this.paramsObj);
      hideLoading();
      await saveBlob("导出车辆.xls", res.data);
    },
    refresh() {
      this.queryCarList();
    },
    reset() {
      this.searchFormData = {
        reportTime: null
      };
      this.carNum = null;
      this.owner = null;
      this.transportCardNum = null;
      this.archivesNum = null;
      this.businessNum = null;
      this.hasFile = null;
      this.truckExist = null;
    },
    async getDict() {
      let res = await $api.dict.get("searchDic");
      if (res.status === 1) {
        this.dict = res.data;
        this.queryCarList();
      } else {
        this.$XModal.message(res.message);
      }
    },
    async queryCarList() {
      let reportTime = this.searchFormData.reportTime;
      let reportTimeBegin = null;
      let reportTimeEnd = null;
      if (reportTime && reportTime.length > 0) {
        reportTimeBegin = moment(reportTime[0]).valueOf(); // 开始时间
        reportTimeEnd = moment(reportTime[1]).valueOf() + 86399999; // 结束时间
      }
      this.paramsObj = {
        reportStatus: this.reportStatus,
        // reportCompany: this.reportCompany,
        reportUser: this.reportUser,
        reportTimeBegin: reportTimeBegin,
        reportTimeEnd: reportTimeEnd,
        carNum: this.carNum,
        owner: this.owner,
        transportCardNum: this.transportCardNum,
        archivesNum: this.archivesNum,
        businessNum: this.businessNum,
        hasFile: this.hasFile,
        truckExist: this.truckExist,
        orderBy: this.orderBy,
        isDesc: this.isDesc,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        sourceType: 1,
        authStatus: this.authStatus,
        hasBusinessNum: this.hasBusinessNum,
        carTypeText: this.carTypeText.length > 0 ? this.carTypeText[this.carTypeText.length - 1] : null
      }
      this.loading = true;
      let res = await $api.carShip.request('queryCarList', this.paramsObj);
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        let data = res.data.rows;
        let dict = this.dict;
        data.map(i => {
          if (i.carTypeText) {
            let carTypeList = i.carTypeText.split(',');
            i.carTypeText = carTypeList;
            let carType = '';
            dict.map(i => {
              if (parseInt(carTypeList[1]) === i.dictCode) {
                carType = i.dictText
              }
            })
            i.carType = carType;
          }
          if (i.carNumColor) {
            dict.map(j => {
              if (i.carNumColor === j.dictCode) {
                i.carColor = j.dictText;
              }
            })
          }
        })
        this.tableData = res.data.rows;
        this.tableData.map((i) => {
          this.records.map((j) => {
            if (i.id === j.id) {
              this.$refs.xTable.setCheckboxRow(i, true);
            }
          });
        });
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    search() {
      this.page.currentPage = 1
      this.queryCarList();
    },
    changePage(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.queryCarList();
    },
    showAddModal() {
      this.createTitle = '新增车辆信息'
      this.createVisible = true;
      this.$refs.modalCreate.showUpdate();
    },
    showDetail(row) {
      this.createTitle = '查看车辆信息'
      this.createVisible = true;
      this.$refs.modalCreate.setUpdate(row);
      this.$refs.modalCreate.setReadOnly();
    },
    openUpdateView(row) {
      this.createTitle = '编辑车辆信息'
      this.createVisible = true;
      this.$refs.modalCreate.setUpdate(row);
      this.$refs.modalCreate.showUpdate();
    },
    commitDelete(id) {
      this.$XModal.confirm('您确定要删除吗？').then(type => {
        if (type === 'confirm') {
          this.deleteCar(id);
        }
      })
    },
    async deleteCar(id) {
      let res = await $api.carShip.request('removeCar', {id: id});
      if (res.status === 1) {
        this.$Message.success('删除成功');
        this.queryCarList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    closeImportModal(type) {
      this.importVisible = false;
      if (type === 'afterSave') {
        this.queryCarList();
      }
    },
    closeCreateModal(type) {
      this.createVisible = false;
      if (type === 'afterSave') {
        this.queryCarList();
      }
    },
    closeImport() {
      this.$refs.modalImport.close();
    },
    closeCreate() {
      this.$refs.modalCreate.reset();
    },
  }
}
</script>

<style>
@import "../../../src/assets/icon/icon-navigate/iconfont.css";

.modal-container {
  position: relative;
  height: 100%
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.navigate, .navigate:active, .navigate:focus, .navigate:hover {
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
}
</style>
<style scoped>
 .cascader >>> input {
   height: 34px;
 }
</style>